module.exports = {
    // fix phases key to top of viewport on scroll
    init: () => {
        // this is the list of nodes that contain <span>ACRONYM</span>
        const acronymsSpansList = document.querySelectorAll(
            ".process_map__definitions__item__content__tables__table__content__right>ul>li>span, " +
            ".process_map__definitions__item__content__heading__body>span, " +
            ".process_map__definitions__item__content__tables__table__header>ul>li>span, " +
            ".process_map__definitions__item__content__tables__table__content__left>ol>li>span, " +
            ".process_map__definitions__item__title_content__title>span, " +
            ".process_map__lane__line__toggle__title>span, " +
            ".process_map__lane__sub_lane__toggle__text>span, " +
            ".process_map__definitions__item__content__description>span, " +
            ".process_map__definitions__item__title>span, " +
            ".process_map__definitions__item__sub_title>span, " +
            ".process_map__definitions__item__content__section__body>span"
        );

        function insertTooltip (laneTitleChild) {
            // function that create and insert tooltip on mouseenter event
            laneTitleChild.addEventListener("mouseenter", (event) => {
                let acronym = laneTitleChild.firstChild.textContent;
                let tooltipText;
                // get corresponding text for tooltip
                switch (acronym) {
                    case "CMC":
                        tooltipText = "Chemistry, Manufacturing & Controls";
                        break;
                    case "IND":
                        tooltipText = "Investigational New Drug";
                        break;
                    case "NDA":
                        tooltipText = "Non-Disclosure Agreement";
                        break;
                    case "FIH":
                        tooltipText = "First in Human Study";
                        break;
                    case "URS":
                        tooltipText = "User Requirements Specification";
                        break;
                    case "PoC":
                        tooltipText = "Proof of Concept";
                        break;
                    case "LCS":
                        tooltipText = "Lead Chemical Series Selection";
                        break;
                    case "PCD":
                        tooltipText = "Preclinical Candidate Development";
                        break;
                    case "EP1":
                        tooltipText = "End of Phase 1";
                        break;
                    case "EP2":
                        tooltipText = "End of Phase 2";
                        break;
                    case "DTF":
                        tooltipText = "Decision to File";
                        break;
                    case "COGS":
                        tooltipText = "Cost of Goods Sold";
                        break;
                    case "PDWF":
                        tooltipText = "Product Development Work Flow";
                        break;
                    case "IPDP":
                        tooltipText = "Integrated Project Development Plan";
                        break;
                    case "PQ / LR":
                        tooltipText = "Product Qualification";
                        break;
                };

                // create tooltip element, put needed text and stylie string in it
                let tooltipTextNode = document.createTextNode(tooltipText);
                let tooltip = document.createElement("DIV");
                tooltip.classList.add("tooltip");
                // different styles for tooltip depending if acronym is inside the right part of node table or not
                if (laneTitleChild.parentElement.parentElement.parentElement.classList.contains("process_map__definitions__item__content__tables__table__content__right")) {
                    tooltip.style.cssText = "z-index: 100; color: #ffffff; background-color: #252525; padding: 10px; position: absolute; right: 40px; top: -1em; width: 270px; font-size: 13px; font-family: din--light;";
                } else if (laneTitleChild.parentElement.classList.contains("process_map__definitions__item__title_content__title")) {
                    tooltip.style.cssText = "z-index: 100; color: #ffffff; background-color: #252525; padding: 10px; position: absolute; left: 110px; top: 0; width: 270px; font-size: 13px; font-family: din--light;";
                } else if (laneTitleChild.parentElement.classList.contains("process_map__definitions__item__title")) {
                    tooltip.style.cssText = "z-index: 100; color: #ffffff; background-color: #252525; padding: 10px; position: absolute; left: 105px; top: -0.5em; width: 270px; font-size: 13px; font-family: din--light;";
                } else {
                    tooltip.style.cssText = "z-index: 100; color: #ffffff; background-color: #252525; padding: 10px; position: absolute; left: 70px; top: -1em; width: 270px; font-size: 13px; font-family: din--light;";
                }
                tooltip.appendChild(tooltipTextNode);
                laneTitleChild.appendChild(tooltip);

                // create arrow and add it to tooltip
                let arrow = document.createElement("DIV");
                // different styles for arrow depending if acronym is inside the right part of node table or not
                if (laneTitleChild.parentElement.parentElement.parentElement.classList.contains("process_map__definitions__item__content__tables__table__content__right")) {
                    arrow.style.cssText = "border: 10px solid transparent; border-left: 10px solid #252525; position: absolute; bottom: 1em; right: -20px";
                } else {
                    arrow.style.cssText = "border: 10px solid transparent; border-right: 10px solid #252525; position: absolute; bottom: 1em; left: -20px";
                }
                tooltip.appendChild(arrow);
            });
            laneTitleChild.addEventListener("mouseleave", (event) => {
                // remove tooltip on mouseleave
                document.querySelector(".tooltip").remove();
            });
        };

        for (let i = 0; i < acronymsSpansList.length; i++) {
            const icon = document.querySelector(".process_map__phases__action__icon");
            const acronymIcon = icon.cloneNode(true);
            acronymIcon.style.fill = "#f26825";
            const acronymsSpan = acronymsSpansList[i];
            acronymsSpan.appendChild(acronymIcon);

            // run insertTooltip function for all <span>ACRONYM</span>
            if (acronymsSpan.children.length > 0) {
                // this condition is for <span>ACRONYM</span> that are inside of other spans
                // insertTooltip(acronymsSpansList[i].children[0]);
                insertTooltip(acronymsSpan);
            } else if (acronymsSpansList[i]) {
                insertTooltip(acronymsSpansList[i]);
            };
        };
    }
};
